// extracted by mini-css-extract-plugin
module.exports = {"base":"_1hA9VogeriW_ToeugKu1S"};